import { Theme } from "@mui/material";

export const getStyles = (theme: Theme, isLast?: boolean) => {
  return isLast ? {
    color: theme.palette.primary.main,
  } : {
    color: theme.palette.grey[600],
    ":hover": {
      color: theme.palette.primary.main,
    }
  };
};